import * as Sentry from '@sentry/browser';

export const captureErrorInSentryWithCustomMessage = (
  error: unknown,
  message: string,
) => {
  Sentry.captureException(error, (scope) =>
    scope.setExtra('CE_message', message));
};
